export const DONE = 'DONE'
export const CRAFT = 'CRAFT'
export const REWARD = 'REWARD'
export const KAPPA = 'KAPPA'
